import React, { memo } from 'react';

import { Heading } from 'components/Atoms';

import { Star } from '../PlacesItem/styles';
import * as S from './styles';

export const NoFavorites = memo(() => (
  <S.NoFavoritesWrapper id="NoFavoritesPlaces" data-testid="NoFavoritesPlaces">
    <Heading level={6} id="NoFavoritesPlaces">
      A gente sempre tem um preferido.
    </Heading>
    <p>
      Toque na{' '}
      <Star isFavorite={false}>
        <div />
      </Star>{' '}
      e adicione seus restaurantes
    </p>
    <p>favoritos aqui.</p>
  </S.NoFavoritesWrapper>
));
